<h3>{{(data.isNew? 'New ' : '') + 'Release notes for ' + data.metadataLabel}}</h3>
<br />
<form [formGroup]="editForm">
  @if (!data.isNew) {
    <div style="display: flex;">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Created by</mat-label>
        <input matInput [value]="editForm.value.createdByUser" readonly />
      </mat-form-field>
    </div>
    <div style="display: flex;">
      <mat-form-field appearance="outline" style="width: 100%" floatLabel="always">
        <mat-label>Last modify</mat-label>
        <input matInput [value]="editForm.value.changedByUser" readonly />
      </mat-form-field>
    </div>
  }
  <div style="display: flex; gap: 10px;">
    <!-- Language -->
    <div (click)="onLanguageFormFieldClick()" style="flex: 1" [style.pointerEvents]="!data.isNew ? 'none' : 'auto'">
      <mat-form-field appearance="outline"
        [ngClass]="{'editable-outline': data.isNew}"
        style="width: 100%">
        <mat-label>Language</mat-label>
        @if (data.isNew) {
          <button mat-icon-button matSuffix tabindex="-1" style="pointer-events: none;">
            <mat-icon class="icon-color-fix-orange">search</mat-icon>
          </button>
        }
        <input type="text"
          matInput
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="selectedLanguageId"
          [matAutocomplete]="auto"
          (input)="onLanguageFilter($event)"
          placeholder="Search"
          [readonly]="!data.isNew" />
          <mat-autocomplete #auto="matAutocomplete"
            [displayWith]="getLanguageText.bind(this)"
            (optionSelected)="onLanguageSelected($event)">
            @for (lan of filteredLanguages; track lan) {
              <mat-option [value]="lan.LanguageId">
                {{ getLanguageText(lan.LanguageId) }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <!-- Date Created/Modified -->
      @if (!data.isNew) {
        <div style="flex: 1">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{editForm.value.changedAtUtc != null ? 'Date modified' : 'Date created'}}</mat-label>
            <input matInput [value]="datePipe.transform(editForm.value.changedAtUtc ?? editForm.value.createdAtUtc,'yyyy-MM-dd')" readonly />
          </mat-form-field>
        </div>
      }
    </div>
    <div style="display: flex; gap: 10px; align-items: stretch;">
      <!-- Change Release Notes File -->
      <div (click)="fileInput.click()" style="flex: 2">
        <mat-form-field appearance="outline"
          [ngClass]="{'editable-outline': true}"
          style="width: 100%"
          floatLabel="always">
          <mat-label>Release notes File</mat-label>
          <input matInput
            [value]="editForm.value.fileName ?? ''"
            readonly
            [placeholder]="!editForm.value.fileName ? 'No file selected' : ''" />
            <input #fileInput
              type="file"
              style="display: none"
              (change)="onFileChange($event)" />
              <button mat-icon-button
                matSuffix
                aria-label="Browse file">
                <mat-icon matSuffix class="icon-color-fix-orange">sync</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <!-- Edit and save Release Notes File -->
          @if (!data.isNew) {
            <div style="display: flex; flex-direction: row; gap: 6px; align-items: stretch; height: 100%;">
              <button class="btn button-fix button-color-fix-edit edit-btn-full-height"
                mat-button
                [disabled]="isFileChanged"
                (click)="onEditFileContent()"
                [matTooltip]="isFileChanged ? 'The file has not been saved yet' : 'Edit file content'">
                Edit
                <mat-icon class="icon-color-fix">edit</mat-icon>
              </button>
            </div>
          }
        </div>
        <mat-dialog-actions [align]="'end'">
          <button class="btn button-fix button-color-fix-red" mat-button (click)="onCancel()" cdkFocusInitial>Cancel</button>
          <button class="btn button-fix button-color-fix-orange"
            mat-button
            [disabled]="!anyChange()"
            (click)="onSave()"
            [matTooltip]="anyChange() ? (data.isNew ? 'Create new Release notes' : 'Save changes') : 'Please set values'">
            {{data.isNew ? 'Create' : 'Save'}}
            <mat-icon style="color:white !important" class="icon-color-fix">{{data.isNew ? 'add_box' : 'save'}}</mat-icon>
          </button>
        </mat-dialog-actions>
      </form>